import { setTerms } from './helpers';

export const setIds = setTerms('ids');
